import { defineMessages } from "locales/defineMessages";

export default defineMessages({
  vi: {
    // Staff attendance (monthly timesheet)
    "staffAttendance.title": "Bảng chấm công nhân viên theo tháng",
    "staffAttendance.description":
      "Bấm vào từng ô để xem chi tiết ca trong ngày hoặc xuất Excel.",
    "staffAttendance.exportExcel": "Xuất Excel",
    "staffAttendance.exportExcelCount": "Xuất Excel ({count})",
    "staffAttendance.loadFailed": "Không tải được dữ liệu chấm công từ API.",
    "staffAttendance.loadingTimesheet": "Đang tải dữ liệu chấm công...",
    "staffAttendance.emptyTitle": "Chưa có dữ liệu chấm công",
    "staffAttendance.emptyDescription": "Vui lòng thử lại hoặc chọn tháng khác",
    "staffAttendance.noMatchingData": "Không có dữ liệu phù hợp.",
    "staffAttendance.noSessionsInMonth": "Không có ca dạy nào trong tháng này.",
    "staffAttendance.noAttendanceDaysInMonth":
      "Không có ngày chấm công nào trong tháng này.",
    "staffAttendance.noSessionsOnDay":
      "Ngày này chưa có ca nào trong hệ thống.",
    "staffAttendance.noSessionsInDay": "Không có ca nào trong ngày",
    "staffAttendance.noSessions": "Không có ca",
    "staffAttendance.sessionCount": "{count} ca",
    "staffAttendance.daySummary": "{count} ca · {hours}h",
    "staffAttendance.dayLabel": "Ngày {date}",
    "staffAttendance.inOutInline": "In: {checkIn} · Out: {checkOut}",
    "staffAttendance.selfOption": "{name} (Bạn)",
    "staffAttendance.searchPlaceholder": "Tên, email",
    "staffAttendance.legend": "Chú thích:",
    "staffAttendance.legendHours": "Số giờ làm trong ngày",
    "staffAttendance.hideEmptyDays":
      "Ẩn những ngày không có chấm công / không check-in, check-out",
    "staffAttendance.hint.selfOnly":
      "Bạn chỉ có thể xem chấm công của mình. Danh sách chỉ hiện những ngày có ca dạy.",
    "staffAttendance.hint.selectedStaff":
      "Nhân viên đã chọn - danh sách chỉ hiện những ngày có ca dạy.",
    "staffAttendance.hint.all":
      "Gợi ý: Bấm vào ngày để xem chi tiết từng ca. Nhãn: V = vắng, P = nghỉ phép, X = check-in, XX = check-out.",

    "staffAttendance.filter.month": "Tháng chấm công",
    "staffAttendance.filter.staff": "Nhân viên",
    "staffAttendance.filter.allStaff": "Tất cả nhân viên",
    "staffAttendance.filter.class": "Lớp học",
    "staffAttendance.filter.allClasses": "Tất cả lớp",
    "staffAttendance.filter.role": "Vai trò",
    "staffAttendance.filter.allRoles": "Tất cả vai trò",

    "staffAttendance.summary.staff": "Nhân viên",
    "staffAttendance.summary.present": "Tổng công",
    "staffAttendance.summary.lateSessions": "Ca muộn",
    "staffAttendance.summary.lateMinutes": "Phút muộn",
    "staffAttendance.summary.absent": "Tổng vắng",
    "staffAttendance.summary.leave": "Nghỉ phép",

    "staffAttendance.stat.present": "Công",
    "staffAttendance.stat.lateSessions": "Ca muộn",
    "staffAttendance.stat.lateMinutes": "Phút muộn",
    "staffAttendance.stat.absent": "Vắng",
    "staffAttendance.stat.leave": "Phép",

    "staffAttendance.abbr.present": "C",
    "staffAttendance.abbr.absent": "V",
    "staffAttendance.abbr.leave": "P",
    "staffAttendance.abbr.late": "M",

    "staffAttendance.col.index": "STT",
    "staffAttendance.col.fullName": "Họ tên",
    "staffAttendance.col.total": "Tổng",
    "staffAttendance.col.totalHours": "Tổng giờ",
    "staffAttendance.col.date": "Ngày",
    "staffAttendance.col.shiftClass": "Ca / Lớp",
    "staffAttendance.col.time": "Thời gian",
    "staffAttendance.col.checkIn": "Check-in",
    "staffAttendance.col.checkOut": "Check-out",
    "staffAttendance.col.status": "Trạng thái",

    "staffAttendance.status.unmarked": "Chưa chấm",
    "staffAttendance.status.checkedIn": "Check-in",
    "staffAttendance.status.checkedOut": "Check-out",
    "staffAttendance.status.checkedInAt": "Check-in {time}",
    "staffAttendance.status.checkedOutAt": "Check-out {time}",
    "staffAttendance.status.absent": "Vắng",
    "staffAttendance.status.excused": "Nghỉ phép",
    "staffAttendance.status.other": "Khác",

    "staffAttendance.short.unmarked": "-",
    "staffAttendance.short.checkedIn": "X",
    "staffAttendance.short.checkedOut": "XX",
    "staffAttendance.short.absent": "V",
    "staffAttendance.short.excused": "P",
    "staffAttendance.short.other": "?",

    "staffAttendance.meta.upcoming": "Chưa diễn ra",
    "staffAttendance.meta.excused": "Nghỉ phép",
    "staffAttendance.meta.absent": "Vắng",
    "staffAttendance.meta.late": "Muộn {duration}",
    "staffAttendance.meta.forgotCheckout": "Quên check-out",
    "staffAttendance.meta.early": "Sớm {duration}",
    "staffAttendance.meta.onTime": "Đúng giờ",
    "staffAttendance.meta.unmarked": "Chưa chấm",
    "staffAttendance.meta.pending": "Đang chờ chấm",

    "staffAttendance.duration.minutes": "{minutes}p",
    "staffAttendance.duration.hours": "{hours}h",
    "staffAttendance.duration.hoursMinutes": "{hours}h {minutes}p",

    "staffAttendance.weekday.sun": "CN",
    "staffAttendance.weekday.mon": "T2",
    "staffAttendance.weekday.tue": "T3",
    "staffAttendance.weekday.wed": "T4",
    "staffAttendance.weekday.thu": "T5",
    "staffAttendance.weekday.fri": "T6",
    "staffAttendance.weekday.sat": "T7",

    "staffAttendance.shift.HC": "Hành chính 08:00-17:00",
    "staffAttendance.shift.HC7": "Hành chính Thứ 7 08:00-12:00",
    "staffAttendance.shift.CC1330": "Ca chiều 13:30-21:30",
    "staffAttendance.shift.CC1400": "Ca chiều 14:00-22:00",
    "staffAttendance.shift.CC1415": "Ca chiều 14:15-22:15",
    "staffAttendance.shift.CC1430": "Ca chiều 14:30-22:30",
    "staffAttendance.shift.CC1500": "Ca chiều 15:00-23:00",
    "staffAttendance.shift.CD": "Ca đêm 22:00-06:00",

    "staffAttendance.export.personalTitle":
      "BẢNG CHẤM CÔNG CÁ NHÂN - THÁNG {month}/{year}",
    "staffAttendance.export.codeEmail": "Mã NV: {code} · Email: {email}",
    "staffAttendance.export.presentCount": "Công: {count}",
    "staffAttendance.export.lateSessionsCount": "Ca muộn: {count}",
    "staffAttendance.export.lateMinutesTotal": "Phút muộn: {duration}",
    "staffAttendance.export.absentCount": "Vắng: {count}",
    "staffAttendance.export.leaveCount": "Phép: {count}",
    "staffAttendance.export.shiftN": "Ca {index}",
    "staffAttendance.export.inOut": "In: {checkIn}  Out: {checkOut}",
    "staffAttendance.export.summarySheetName": "Tổng hợp",
    "staffAttendance.export.defaultSheetName": "Bảng chấm công",

    "staffAttendance.exportModal.title": "Chọn nhân viên xuất Excel",
    "staffAttendance.exportModal.description":
      "Tick chọn những người bạn muốn xuất. Bỏ trống = xuất tất cả.",
    "staffAttendance.exportModal.searchPlaceholder":
      "Tìm theo tên, mã NV, email...",
    "staffAttendance.exportModal.allPositions": "Tất cả chức vụ",
    "staffAttendance.exportModal.selected": "Đã chọn: {selected} / {total}",
    "staffAttendance.exportModal.selectedFiltered":
      "Đã chọn: {selected} / {total} (hiện {shown})",
    "staffAttendance.exportModal.selectVisible": "Chọn hiện tại",
    "staffAttendance.exportModal.deselectVisible": "Bỏ hiện tại",
    "staffAttendance.exportModal.noMatch":
      "Không có nhân viên nào khớp bộ lọc.",

    // System admin face check logs
    "faceLogs.title": "Nhật ký nhận diện khuôn mặt",
    "faceLogs.col.photo": "Ảnh",
    "faceLogs.col.user": "Người dùng",
    "faceLogs.col.score": "Điểm số",
    "faceLogs.col.result": "Kết quả",
    "faceLogs.col.session": "Buổi học",
    "faceLogs.col.time": "Thời gian",
    "faceLogs.col.verify": "Xác minh",
    "faceLogs.matched": "Khớp",
    "faceLogs.notMatched": "Không khớp",
    "faceLogs.filterAll": "Tất cả",
    "faceLogs.fromDate": "Từ ngày",
    "faceLogs.toDate": "Đến ngày",
    "faceLogs.searchUserPlaceholder": "Tìm theo tên hoặc email...",
    "faceLogs.downloadImage": "Tải ảnh",
    "faceLogs.unrecognized": "Không nhận diện được",
    "faceLogs.verify": "Xác minh",
    "faceLogs.reverify": "Xác minh lại",
    "faceLogs.verifyFailed": "Xác minh thất bại",
    "faceLogs.verifying": "Đang xác minh...",
    "faceLogs.verifyResultTitle": "Kết quả xác minh",
    "faceLogs.compareWithParticipant": "So sánh với học viên trong buổi học",
    "faceLogs.originalUser": "-- Người dùng gốc --",
    "faceLogs.compare": "So sánh",
    "faceLogs.userLabel": "Người dùng:",
    "faceLogs.unknownUser": "Không xác định",
    "faceLogs.bestScoreLabel": "Điểm cao nhất:",
    "faceLogs.compareWithRegistered": "So sánh với các ảnh đã đăng ký",
    "faceLogs.facePhotosTitle": "Ảnh khuôn mặt — {name}",
    "faceLogs.noFacePhotos": "Người dùng chưa đăng ký ảnh khuôn mặt nào.",
    "faceLogs.noImage": "Không có ảnh",
    "faceLogs.empty": "Không có dữ liệu nhận diện nào.",
    "faceLogs.rowsPerPage": "Hàng/trang:",
    "faceLogs.totalRecords": "Tổng {count} bản ghi",
    "faceLogs.prev": "Trước",
    "faceLogs.next": "Tiếp",
    "faceLogs.pageOf": "Trang {page} / {total}",

    // Face enrollment card
    "faceEnroll.title": "Đăng ký khuôn mặt",
    "faceEnroll.subtitle": "Cần {count} góc ảnh để điểm danh tự động",
    "faceEnroll.slot.front": "Nhìn thẳng",
    "faceEnroll.slot.left": "Nghiêng trái",
    "faceEnroll.slot.right": "Nghiêng phải",
    "faceEnroll.instruction.front": "Nhìn thẳng vào camera",
    "faceEnroll.instruction.left": "Nghiêng mặt sang trái",
    "faceEnroll.instruction.right": "Nghiêng mặt sang phải",
    "faceEnroll.registeredPhotos": "Ảnh đăng ký khuôn mặt",
    "faceEnroll.notRegistered": "Chưa đăng ký",
    "faceEnroll.allComplete": "Đã đăng ký đủ khuôn mặt!",
    "faceEnroll.ready": "Hệ thống điểm danh khuôn mặt sẵn sàng hoạt động.",
    "faceEnroll.readyCanModify":
      'Hệ thống điểm danh khuôn mặt sẵn sàng hoạt động. Bấm "Chụp lại" để thay đổi ảnh bất kỳ.',
    "faceEnroll.retake": "Chụp lại",
    "faceEnroll.stepTitle": "Bước {step}: {name}",
    "faceEnroll.stepDone": "{name} - Đã hoàn thành",
    "faceEnroll.uploading": "Đang tải lên...",
    "faceEnroll.processing": "Đang xử lý...",
    "faceEnroll.confirmUpload": "Xác nhận & Tải lên",
    "faceEnroll.remainingHint":
      "Còn thiếu {count} góc ảnh. Chụp từng góc và hệ thống sẽ tự động chuyển sang góc tiếp theo.",
    "faceEnroll.error.cameraAccess":
      "Không thể truy cập camera. Vui lòng kiểm tra quyền truy cập.",
    "faceEnroll.error.processCaptureFailed": "Không thể xử lý ảnh vừa chụp",
    "faceEnroll.error.readFileFailed": "Không thể đọc file ảnh",
    "faceEnroll.error.loadFailed": "Không thể tải danh sách ảnh khuôn mặt",
    "faceEnroll.error.uploadFailed": "Upload ảnh thất bại",
    "faceEnroll.error.uploadFaceFailed": "Upload ảnh khuôn mặt thất bại",
    "faceEnroll.error.deleteFailed": "Xóa ảnh thất bại",
    "faceEnroll.error.faceTooSmall":
      "Khuôn mặt trong ảnh quá nhỏ hoặc quá xa camera. Hãy đưa mặt lại gần hơn, chiếm nhiều khung hình hơn và thử lại.",
    "faceEnroll.error.noFaceDetected":
      "Hệ thống không nhận diện được khuôn mặt. Hãy chụp rõ mặt, đủ sáng, không che mặt và thử lại.",
    "faceEnroll.error.invalidImage":
      "Ảnh tải lên không hợp lệ hoặc bị lỗi. Hãy chọn ảnh khác và thử lại.",
  },
  en: {
    // Staff attendance (monthly timesheet)
    "staffAttendance.title": "Monthly staff timesheet",
    "staffAttendance.description":
      "Click a cell to see that day's shifts, or export to Excel.",
    "staffAttendance.exportExcel": "Export Excel",
    "staffAttendance.exportExcelCount": "Export Excel ({count})",
    "staffAttendance.loadFailed": "Couldn't load attendance data from the API.",
    "staffAttendance.loadingTimesheet": "Loading timesheet...",
    "staffAttendance.emptyTitle": "No attendance data yet",
    "staffAttendance.emptyDescription": "Try again or pick another month",
    "staffAttendance.noMatchingData": "No matching data.",
    "staffAttendance.noSessionsInMonth": "No teaching shifts this month.",
    "staffAttendance.noAttendanceDaysInMonth": "No attendance days this month.",
    "staffAttendance.noSessionsOnDay": "There are no shifts on this day yet.",
    "staffAttendance.noSessionsInDay": "No shifts on this day",
    "staffAttendance.noSessions": "No shifts",
    "staffAttendance.sessionCount": "{count} shift(s)",
    "staffAttendance.daySummary": "{count} shift(s) · {hours}h",
    "staffAttendance.dayLabel": "Date {date}",
    "staffAttendance.inOutInline": "In: {checkIn} · Out: {checkOut}",
    "staffAttendance.selfOption": "{name} (You)",
    "staffAttendance.searchPlaceholder": "Name, email",
    "staffAttendance.legend": "Legend:",
    "staffAttendance.legendHours": "Hours worked that day",
    "staffAttendance.hideEmptyDays":
      "Hide days with no attendance / no check-in or check-out",
    "staffAttendance.hint.selfOnly":
      "You can only view your own attendance. Only days with teaching shifts are listed.",
    "staffAttendance.hint.selectedStaff":
      "Selected staff member — only days with teaching shifts are listed.",
    "staffAttendance.hint.all":
      "Tip: click a day to see each shift. Labels: A = absent, L = on leave, X = check-in, XX = check-out.",

    "staffAttendance.filter.month": "Timesheet month",
    "staffAttendance.filter.staff": "Staff",
    "staffAttendance.filter.allStaff": "All staff",
    "staffAttendance.filter.class": "Class",
    "staffAttendance.filter.allClasses": "All classes",
    "staffAttendance.filter.role": "Role",
    "staffAttendance.filter.allRoles": "All roles",

    "staffAttendance.summary.staff": "Staff",
    "staffAttendance.summary.present": "Total worked",
    "staffAttendance.summary.lateSessions": "Late shifts",
    "staffAttendance.summary.lateMinutes": "Late minutes",
    "staffAttendance.summary.absent": "Total absent",
    "staffAttendance.summary.leave": "On leave",

    "staffAttendance.stat.present": "Worked",
    "staffAttendance.stat.lateSessions": "Late shifts",
    "staffAttendance.stat.lateMinutes": "Late minutes",
    "staffAttendance.stat.absent": "Absent",
    "staffAttendance.stat.leave": "Leave",

    "staffAttendance.abbr.present": "W",
    "staffAttendance.abbr.absent": "A",
    "staffAttendance.abbr.leave": "L",
    "staffAttendance.abbr.late": "LT",

    "staffAttendance.col.index": "No.",
    "staffAttendance.col.fullName": "Full name",
    "staffAttendance.col.total": "Total",
    "staffAttendance.col.totalHours": "Total hours",
    "staffAttendance.col.date": "Date",
    "staffAttendance.col.shiftClass": "Shift / Class",
    "staffAttendance.col.time": "Time",
    "staffAttendance.col.checkIn": "Check-in",
    "staffAttendance.col.checkOut": "Check-out",
    "staffAttendance.col.status": "Status",

    "staffAttendance.status.unmarked": "Not marked",
    "staffAttendance.status.checkedIn": "Check-in",
    "staffAttendance.status.checkedOut": "Check-out",
    "staffAttendance.status.checkedInAt": "Check-in {time}",
    "staffAttendance.status.checkedOutAt": "Check-out {time}",
    "staffAttendance.status.absent": "Absent",
    "staffAttendance.status.excused": "On leave",
    "staffAttendance.status.other": "Other",

    "staffAttendance.short.unmarked": "-",
    "staffAttendance.short.checkedIn": "X",
    "staffAttendance.short.checkedOut": "XX",
    "staffAttendance.short.absent": "A",
    "staffAttendance.short.excused": "L",
    "staffAttendance.short.other": "?",

    "staffAttendance.meta.upcoming": "Not started",
    "staffAttendance.meta.excused": "On leave",
    "staffAttendance.meta.absent": "Absent",
    "staffAttendance.meta.late": "Late {duration}",
    "staffAttendance.meta.forgotCheckout": "Missed check-out",
    "staffAttendance.meta.early": "Early {duration}",
    "staffAttendance.meta.onTime": "On time",
    "staffAttendance.meta.unmarked": "Not marked",
    "staffAttendance.meta.pending": "Awaiting attendance",

    "staffAttendance.duration.minutes": "{minutes}m",
    "staffAttendance.duration.hours": "{hours}h",
    "staffAttendance.duration.hoursMinutes": "{hours}h {minutes}m",

    "staffAttendance.weekday.sun": "Sun",
    "staffAttendance.weekday.mon": "Mon",
    "staffAttendance.weekday.tue": "Tue",
    "staffAttendance.weekday.wed": "Wed",
    "staffAttendance.weekday.thu": "Thu",
    "staffAttendance.weekday.fri": "Fri",
    "staffAttendance.weekday.sat": "Sat",

    "staffAttendance.shift.HC": "Office hours 08:00-17:00",
    "staffAttendance.shift.HC7": "Saturday office hours 08:00-12:00",
    "staffAttendance.shift.CC1330": "Afternoon shift 13:30-21:30",
    "staffAttendance.shift.CC1400": "Afternoon shift 14:00-22:00",
    "staffAttendance.shift.CC1415": "Afternoon shift 14:15-22:15",
    "staffAttendance.shift.CC1430": "Afternoon shift 14:30-22:30",
    "staffAttendance.shift.CC1500": "Afternoon shift 15:00-23:00",
    "staffAttendance.shift.CD": "Night shift 22:00-06:00",

    "staffAttendance.export.personalTitle":
      "PERSONAL TIMESHEET - {month}/{year}",
    "staffAttendance.export.codeEmail": "Staff code: {code} · Email: {email}",
    "staffAttendance.export.presentCount": "Worked: {count}",
    "staffAttendance.export.lateSessionsCount": "Late shifts: {count}",
    "staffAttendance.export.lateMinutesTotal": "Late minutes: {duration}",
    "staffAttendance.export.absentCount": "Absent: {count}",
    "staffAttendance.export.leaveCount": "Leave: {count}",
    "staffAttendance.export.shiftN": "Shift {index}",
    "staffAttendance.export.inOut": "In: {checkIn}  Out: {checkOut}",
    "staffAttendance.export.summarySheetName": "Summary",
    "staffAttendance.export.defaultSheetName": "Timesheet",

    "staffAttendance.exportModal.title": "Choose staff to export",
    "staffAttendance.exportModal.description":
      "Tick the people you want to export. Leave empty to export everyone.",
    "staffAttendance.exportModal.searchPlaceholder":
      "Search by name, staff code, email...",
    "staffAttendance.exportModal.allPositions": "All positions",
    "staffAttendance.exportModal.selected": "Selected: {selected} / {total}",
    "staffAttendance.exportModal.selectedFiltered":
      "Selected: {selected} / {total} ({shown} shown)",
    "staffAttendance.exportModal.selectVisible": "Select shown",
    "staffAttendance.exportModal.deselectVisible": "Deselect shown",
    "staffAttendance.exportModal.noMatch": "No staff match the filters.",

    // System admin face check logs
    "faceLogs.title": "Face recognition log",
    "faceLogs.col.photo": "Photo",
    "faceLogs.col.user": "User",
    "faceLogs.col.score": "Score",
    "faceLogs.col.result": "Result",
    "faceLogs.col.session": "Session",
    "faceLogs.col.time": "Time",
    "faceLogs.col.verify": "Verify",
    "faceLogs.matched": "Matched",
    "faceLogs.notMatched": "Not matched",
    "faceLogs.filterAll": "All",
    "faceLogs.fromDate": "From",
    "faceLogs.toDate": "To",
    "faceLogs.searchUserPlaceholder": "Search by name or email...",
    "faceLogs.downloadImage": "Download image",
    "faceLogs.unrecognized": "Not recognized",
    "faceLogs.verify": "Verify",
    "faceLogs.reverify": "Verify again",
    "faceLogs.verifyFailed": "Verification failed",
    "faceLogs.verifying": "Verifying...",
    "faceLogs.verifyResultTitle": "Verification result",
    "faceLogs.compareWithParticipant": "Compare with a session participant",
    "faceLogs.originalUser": "-- Original user --",
    "faceLogs.compare": "Compare",
    "faceLogs.userLabel": "User:",
    "faceLogs.unknownUser": "Unknown",
    "faceLogs.bestScoreLabel": "Best score:",
    "faceLogs.compareWithRegistered": "Comparison with registered photos",
    "faceLogs.facePhotosTitle": "Face photos — {name}",
    "faceLogs.noFacePhotos": "This user hasn't registered any face photos.",
    "faceLogs.noImage": "No image",
    "faceLogs.empty": "No recognition records.",
    "faceLogs.rowsPerPage": "Rows/page:",
    "faceLogs.totalRecords": "{count} records in total",
    "faceLogs.prev": "Previous",
    "faceLogs.next": "Next",
    "faceLogs.pageOf": "Page {page} / {total}",

    // Face enrollment card
    "faceEnroll.title": "Face enrollment",
    "faceEnroll.subtitle": "{count} angles are needed for automatic attendance",
    "faceEnroll.slot.front": "Front",
    "faceEnroll.slot.left": "Turn left",
    "faceEnroll.slot.right": "Turn right",
    "faceEnroll.instruction.front": "Look straight at the camera",
    "faceEnroll.instruction.left": "Turn your face to the left",
    "faceEnroll.instruction.right": "Turn your face to the right",
    "faceEnroll.registeredPhotos": "Registered face photos",
    "faceEnroll.notRegistered": "Not registered",
    "faceEnroll.allComplete": "All face angles registered!",
    "faceEnroll.ready": "Face attendance is ready to use.",
    "faceEnroll.readyCanModify":
      'Face attendance is ready to use. Click "Retake" to replace any photo.',
    "faceEnroll.retake": "Retake",
    "faceEnroll.stepTitle": "Step {step}: {name}",
    "faceEnroll.stepDone": "{name} - Done",
    "faceEnroll.uploading": "Uploading...",
    "faceEnroll.processing": "Processing...",
    "faceEnroll.confirmUpload": "Confirm & upload",
    "faceEnroll.remainingHint":
      "{count} angles left. Capture each one and you'll move to the next angle automatically.",
    "faceEnroll.error.cameraAccess":
      "Can't access the camera. Please check camera permissions.",
    "faceEnroll.error.processCaptureFailed":
      "Couldn't process the captured photo",
    "faceEnroll.error.readFileFailed": "Couldn't read the image file",
    "faceEnroll.error.loadFailed": "Couldn't load face photos",
    "faceEnroll.error.uploadFailed": "Image upload failed",
    "faceEnroll.error.uploadFaceFailed": "Face photo upload failed",
    "faceEnroll.error.deleteFailed": "Failed to delete photo",
    "faceEnroll.error.faceTooSmall":
      "The face in the photo is too small or too far from the camera. Move closer so your face fills more of the frame and try again.",
    "faceEnroll.error.noFaceDetected":
      "No face was detected. Make sure your face is clear, well lit and uncovered, then try again.",
    "faceEnroll.error.invalidImage":
      "The uploaded image is invalid or corrupted. Choose another image and try again.",
  },
});
